var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoctor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 484.336 484.336",
    style: {
      enableBackground: "new 0 0 484.336 484.336"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#ACDCE2"
    },
    points: "304.424,260.073 461.272,313.633 484.336,482.833 249.336,482.833 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E2F5F7"
    },
    points: "179.912,260.073 23.064,313.633 0,482.833 235,482.833 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CEEEF2"
    },
    points: "153.896,373.057 23.064,313.633 0,482.833 235,482.833 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C3E4EA"
    },
    points: "426.192,329.585 304.424,261.841 291.832,314.833 192.504,314.833 179.912,262.537  58.144,330.121 70.736,482.833 187.472,482.833 235,482.833 249.336,482.833 299.064,482.833 413.6,482.833 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E2F5F7"
    },
    points: "143,266.793 122.664,356.793 183.664,375.793 156.664,439.793 242.168,484.289  242.168,437.137 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CEEEF2"
    },
    points: "341.352,266.793 361.664,356.793 300.664,375.793 327.672,439.793 242.168,484.289  242.168,437.137 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8790A"
    },
    d: "M326.256,90.833c0,40.12-30.216,72-67.504,72h-33.168c-37.28,0-67.504-31.88-67.504-72l0,0 c0-40.136,30.216-72,67.504-72h33.168C296.032,18.833,326.256,50.697,326.256,90.833L326.256,90.833z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F9BDA0"
    },
    points: "302.504,290.833 181.832,290.833 189.88,194.833 294.456,194.833 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E28F71"
    },
    points: "302.504,290.833 241.976,290.833 181.832,194.833 294.456,194.833 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCCCB9"
    },
    d: "M323.648,111.689c0,70.872-35.72,135-81.472,135c-45.768,0-81.472-64.128-81.472-135 c0-70.88,35.704-82.68,81.472-82.68C287.928,29.009,323.648,40.809,323.648,111.689z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9BDA0"
    },
    d: "M242.176,29.009c45.752,0,81.472,11.8,81.472,82.68c0,70.872-35.72,135-81.472,135"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6B767C"
    },
    points: "240.192,434.449 168.08,336.585 142.048,266.793 178.736,251.417 242.176,291.569  305.6,251.417 342.288,266.793 316.256,336.585 244.144,434.449 242.112,437.905 "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#4E595E"
    },
    points: "242.176,291.569 305.6,251.417 342.288,266.793 316.256,336.585 244.144,434.449  242.112,437.905 240.192,434.449 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4E595E"
    },
    points: "178.736,251.417 241.976,290.833 168.096,330.681 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#454F54"
    },
    points: "305.6,251.417 241.976,290.833 316.256,330.681 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8790A"
    },
    d: "M161.16,100.945c-4.328-1.896-11.472-22.736-7.656-31.424c3.84-8.704,18.456-6.2,22.768-4.296 c4.344,1.904,7.936,12.784,0.936,19.192"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8790A"
    },
    d: "M323.144,100.761c4.344-1.912,11.528-22.744,7.72-31.432c-3.816-8.68-18.408-6.168-22.752-4.256 c-4.328,1.912-7.952,12.808-0.952,19.192"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8790A"
    },
    d: "M254.568,54.801c0,0,15.832,33.16,75.16,34.496c0,0,22.184-64.496-64.488-76.496L254.568,54.801z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F98821"
    },
    d: "M292.224,37.793c0,0-5,65-135,40c0,0-23-8-20-27c0,0,5,18,18,3c0,0,18.496-56.168,73.504-53.664 S292.224,37.793,292.224,37.793z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8790A"
    },
    d: "M292.224,37.793c0,0-5,65-135,40c0,0-23-8-20-27c0,0,5,18,18,3"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#23343A"
    },
    points: "248.032,290.833 264.584,406.713 242.16,432.705 219.736,406.913 236.32,290.833 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#071519"
    },
    points: "235.176,298.833 249.176,298.833 264.584,406.713 242.16,432.705  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#071519"
    },
    points: "236.568,306.833 233.096,296.905 242.16,290.681 251.224,296.729 247.752,306.833  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M418.568,397.465c0,0.832-0.688,1.504-1.512,1.504h-88.472c-0.832,0-1.504-0.672-1.504-1.504l0,0 c0-0.832,0.672-1.504,1.504-1.504h88.464C417.88,395.961,418.568,396.633,418.568,397.465L418.568,397.465z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E595E"
    },
    d: "M134.168,340.129c-2.2,0-4-1.792-4-4v-74.664c0-24.256,21.752-44,46-44c2.216,0,4.992,1.792,4.992,4 s-3.272,4-5.496,4c-19.84,0-37.504,16.152-37.504,36v74.664C138.168,338.337,136.384,340.129,134.168,340.129z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E595E"
    },
    d: "M342.168,380.129c2.216,0,4-1.792,4-4V261.465c0-24.256-17.736-44-42-44c-2.2,0-3.008,1.792-3.008,4 s0.304,4,2.504,4c19.856,0,34.496,16.152,34.496,36v114.664C338.168,378.337,339.968,380.129,342.168,380.129z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#7CB1B5"
    },
    cx: 342.288,
    cy: 383.289,
    r: 9.336
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37A2A5"
    },
    d: "M371.624,411.857c0,16.192-13.16,29.344-29.328,29.344c-16.216,0-29.344-13.152-29.344-29.344 c0-16.176,13.128-29.328,29.344-29.328C358.464,382.529,371.624,395.681,371.624,411.857z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B8796"
    },
    d: "M321.56,391.121c11.424-11.44,30.032-11.44,41.472,0c11.456,11.456,11.44,30.056,0.016,41.488"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#37A2A5"
    },
    cx: 342.296,
    cy: 411.873,
    r: 15.664
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B8796"
    },
    d: "M331.216,422.937c-6.112-6.096-6.112-16.048,0-22.144c6.112-6.128,16.048-6.112,22.16-0.016"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37A2A5"
    },
    d: "M162.168,460.417L162.168,460.417l-8.28-102c0-8.544-7.104-15.504-15.648-15.504 s-15.784,6.952-15.784,15.504l-8.288,102l0,0v-102c0-12.96,11.048-23.504,24-23.504c12.968,0,24,10.536,24,23.504V460.417z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37A2A5"
    },
    d: "M120.832,457.913c0,5.312,1.296,9.624-1.752,9.624c-3.032,0-5.504-4.312-5.504-9.624 s2.472-9.624,5.504-9.624C122.128,448.289,120.832,452.601,120.832,457.913z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#1B8796"
    },
    cx: 114.568,
    cy: 457.913,
    rx: 4.168,
    ry: 5.664
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37A2A5"
    },
    d: "M155.36,457.913c0-5.312-1.296-9.624,1.752-9.624c3.032,0,5.504,4.312,5.504,9.624 s-2.472,9.624-5.504,9.624C154.064,467.537,155.36,463.225,155.36,457.913z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#1B8796"
    },
    cx: 161.608,
    cy: 457.913,
    rx: 4.168,
    ry: 5.664
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 386.168,
    y: 354.833,
    style: {
      fill: "#4E595E"
    },
    width: 8,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.168,
    y: 362.833,
    style: {
      fill: "#4E595E"
    },
    width: 24,
    height: 8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctor);
export default __webpack_public_path__ + "static/media/doctor.ff30360f75ee4712ef74ee4c4d330e27.svg";
export { ForwardRef as ReactComponent };